module.exports = __webpack_public_path__ + "static/media/18-9.fd1c934e.mp3";